/* eslint-disable ember/classic-decorator-hooks, ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { sortBy } from '@linc-technologies/linced-common/utils/arrays';

export default class GoalsRoute extends Route {
  // Services
  @service
  router;

  @service
  store;

  @service
  strings;

  model() {
    return hash({
      subjects: this.store
        .query('goals/subject', { visibleToTeachers: true })
        .then((subjects) => subjects.filter((subject) => !subject.isTopic)),
      person: this.modelFor('people.person').person,
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    model.subjects = sortBy(model.subjects, 'label');
  }

  init() {
    super.init(...arguments);

    this.router.on('routeDidChange', (transition) => {
      if (transition.to.find((route) => route.name === this.routeName)) {
        // Set activeSubject on the controller so that it can highlight the correct button.
        let subjectId = this.paramsFor(
          'people.person.goals.subject',
        ).subject_id;
        this.controller.set('activeSubject', subjectId);
      }
    });
  }
}
